import { API_ENDPOINTS } from '@framework/utils/endpoints';
import { useTranslation } from 'next-i18next';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { ContactType, CustomerService, CustomerType, UpdateIco } from './customer.service';

export const useUpdateCustomerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (input: CustomerType) => CustomerService.updateCustomer(input),
    {
      // Always refetch after error or success:
      onSettled: () => {
        queryClient.invalidateQueries('me');
      },
    }
  );
};

export const useContactMutation = () => {
  const { t } = useTranslation('common');

  return useMutation((input: ContactType) => CustomerService.contact(input), {
    onSuccess: (data) => {
      if (data.success) {
        toast.success(t(data.message));
      } else {
        toast.error(t(data.message));
      }
    },
  });
};

const verifyEmail = async (email: string): Promise<any> => {
  const response: any = await CustomerService.verifyEmail(email);

  return { verify: !response?.success };
};

export const useVerifyEmailQuery = (
  email: string,
  options: any = {}
) => {
  return useQuery<any, Error>([API_ENDPOINTS.VERIFY_EMAIL, email], () => verifyEmail(email), {
      ...options
    },
  );
};

export const useUpdateIcoCustomerMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (input: UpdateIco) => CustomerService.updateIco(input),
    {
      // Always refetch after error or success:
      onSettled: () => {
        queryClient.invalidateQueries('me');
      },
    }
  );
};

export const useAcceptPolicyMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (input: any) => CustomerService.accept(input),
    {
      // Always refetch after error or success:
      onSettled: () => {
        queryClient.invalidateQueries('me');
      },
    }
  );
};

export const fetchPolicy = async () => {
  const data = await CustomerService.findPolicyByUser();
  return data;
};

export const usePolicyQuery = (options: any = {}) => {
  return useQuery<any, Error>([API_ENDPOINTS.POLICY_BY_USER, options], () =>
    fetchPolicy()
  );
};
